<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight order-children-detail order-unpack">

        <!-- 新建作者订单 [[ -->
        <div class="g-popup author-order-popup js-author-order" style="z-index: 100" v-if="authorOrderDialog.show">
            <div class="popup-con">
                <div class="popup-close js-close-view"><i class="ico ico-close" @click="cancelSubmitAuthorOrder"></i></div>
                <h5 class="popup-title">作者订单</h5>
                <div class="author-order-con">
                    <div class="author-order-item order-name">
                        <p class="title">订单名</p>
                        <input class="author-order-input g-input" type="text" placeholder="请输入作者订单名称"
                               v-model="aOrderParams.orderName"
                        >
                    </div>
                    <div class="author-order-item">
                        <p class="title unpack-time">时间</p>
                        <div class="g-select js-selector2">
                            <div class="set">
                                <el-date-picker v-model="aOrderParams.dateVal"
                                                type="daterange"
                                                :picker-options="authorOderPickerOptions"
                                                range-separator="至"
                                                :start-placeholder="defaultsDate"
                                                :end-placeholder="defaulteDate"
                                                value-format="yyyy-MM-dd"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期"
                                >
                                </el-date-picker>
                            </div>

                        </div>
                    </div>
                    <div class="author-order-item author-order-type">
                        <p class="title">图文</p>
                        <input class="author-order-input g-input" type="text" placeholder="图文数量"
                               v-model="aOrderParams.textNum"
                        >
                        <p class="title">视频</p>
                        <input class="author-order-input g-input" type="text" placeholder="视频数量" v-model="aOrderParams.videoNum">
                    </div>
                    <div class="author-order-item author-order-type">
                        <p class="title">小说</p>
                        <input class="author-order-input g-input" type="text" placeholder="小说数量" v-model="aOrderParams.novelNum">
                        <p class="title">漫画</p>
                        <input class="author-order-input g-input" type="text" placeholder="漫画数量" v-model="aOrderParams.paintingNum">
                    </div>
                    <div class="author-order-item">
                        <p class="title">预期金额</p>
                        <div class="budget f-inlineblock-top">
                            <p class="budget-num f-inlineblock-top">&yen;<span class="budget-num-con f-hide-col-1">{{ getBudget }}</span></p>
                            <div class="budget-icon f-inlineblock-top">
                                <span class="ico ico-question-mark"></span>
                                <div class="budget-con">
                                    <span class="ico ico-triangle"></span>
                                    <div class="budget-con-text">
                                        <p class="text-con">图文<span class="text-color">&yen;150</span>/篇</p>
                                        <p class="text-con">视频<span class="text-color">&yen;400</span>/篇</p>
                                        <p class="text-con">小说<span class="text-color">&yen;250</span>/篇</p>
                                        <p class="text-con">漫画<span class="text-color">&yen;400</span>/篇</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<span class="error-prompt">预算总额大于剩余预算额</span>-->
                    </div>
                    <div class="author-order-item select-option-item">
                        <div class="author-order-select">
                            <label class="tab-item" @click="aOrderParams.authorType = 1">
                                <i class="ico ico-choose" :class="{'ico-choose-pre': aOrderParams.authorType == 1}"></i>团长
                            </label>
                            <label class="tab-item"  @click="aOrderParams.authorType = 2">
                                <i class="ico ico-choose" :class="{'ico-choose-pre': aOrderParams.authorType == 2}"></i>个人作者
                            </label>
                        </div>
                        <div class="change-tabs">
                            <div class="change-tabs-con team-change" v-if="aOrderParams.authorType == 1">
                                <div class="select-team f-clearfix">
                                    <el-select
                                            style="width: 50%"
                                            v-model="aOrderParams.teamId"
                                            filterable
                                            placeholder="请选择团队">
                                        <el-option
                                                v-for="team in teamList"
                                                :key="team.authorTeamName"
                                                :label="team.authorTeamName"
                                                :value="team.id">
                                        </el-option>
                                    </el-select>
                                    <p class="team-change-qq f-inlineblock-top f-fr">团长QQ<span class="qq-con">{{ getTeamLeader }}</span></p>
                                </div>
                            </div>
                            <div class="change-tabs-con person-change" v-else>
                                <p class="title">作者QQ</p>
                                <div class="type-contain f-inlineblock-top">
                                    <input class="type-contain-input g-input"
                                           type="text" placeholder="请输入作者QQ"
                                           v-model="aOrderParams.authorQQ">
                                    <span  v-if="aOrderParams.authorQQ.length"
                                           class="ico ico-lose"
                                           @click="aOrderParams.authorQQ = ''">

                                    </span>
                                </div>
                                <!--<span class="error-prompt">该QQ未注册TGL</span>-->
                            </div>
                        </div>
                    </div>
                    <div class="author-order-item">
                        <p class="title">说明</p>
                        <textarea class="show-input"  rows="" cols="" placeholder="请输入产出和周期说明"
                                  v-model="aOrderParams.cycleExplain"
                        ></textarea>
                    </div>
                </div>
                <div class="author-order-btn">
                    <a class="g-btn preserve-btn js-order-preserve" href="javascript:;"
                       @click="submitAuthorOrder">保存</a>
                    <a class="g-btn" href="javascript:;" @click="cancelSubmitAuthorOrder">取消</a>
                </div>
            </div>
        </div>
        <!-- 新建作者订单 ]] -->
        <!-- 派单[[ -->
        <div class="g-popup g-popup-transparent js-popup-confirm-distribute" v-if="assignOrderDialog.show">
            <div class="popup-con confirm-popup confirm-distribute">
                <div class="popup-close js-close-view"><i class="ico ico-close" @click="assignOrderDialog.show=false"></i></div>
                <h5 class="popup-title">派单确认</h5>
                <p class="confirm-content">派单后，此订单将无法新增及编辑作者订单。是否继续派单？</p>
                <ul class="distribute-list g-scrollbar">
                    <li class="distribute-item" v-for="author in assignOrderDialog.authorList">
                        <span class="item-title">订单派给</span>
                        <div class="distribute-detail">
                            {{ author.userName }}<span class="order-no">{{ author.object_name }}</span>
                        </div>
                    </li>
                </ul>
                <div class="btn-group f-clearfix">
                    <a class="g-btn confirm-btn" href="javascript:;" @click="assignOrder">派单</a>
                    <a class="g-btn cancell f-fr" href="javascript:;" @click="assignOrderDialog.show=false">取消</a>
                </div>
            </div>
        </div>
        <!-- 派单]] -->

        <!-- 结单中止[[ -->
        <div class="g-popup g-popup-transparent js-popup-confirm-commit f-hide">
            <div class="popup-con apply-order-popup">
                <div class="popup-close js-close-view"><i class="ico ico-close"></i></div>
                <h5 class="popup-title">结单中止</h5>
                <p class="confirm-content">中止订单后，作者不能再上传内容、修改金额、提请结单，且实发金额将按照已通过金额的百分比发放</p>
                <div class="order-details">
                    <div class="order-title f-hide-col-1">王者荣耀《报告提莫队长》剪辑内容</div>
                    <div class="order-type-num f-clearfix">
                        <div class="order-types f-fl">
                            <div class="order-type">
                                图文:<div class="num-details"><span class="num">32/</span>32</div>
                            </div>
                            <div class="order-type">
                                小说:<div class="num-details"><span class="num">24/</span>32</div>
                            </div>
                            <div class="order-type">
                                总预算:<div class="num-details">32,324.00</div>
                            </div>
                        </div>
                        <div class="order-types f-fr">
                            <div class="order-type">
                                视频:<div class="num-details"><span class="num">32/</span>32</div>
                            </div>
                            <div class="order-type">
                                漫画:<div class="num-details"><span class="num">24/</span>32</div>
                            </div>
                            <div class="order-type">
                                实际额:<div class="num-details num-detail-orange">32,324.00</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-group f-clearfix">
                    <a class="g-btn confirm-btn" href="javascript:;">中止</a>
                    <a class="g-btn cancell f-fr" href="javascript:;">取消</a>
                </div>
            </div>
        </div>
        <!-- 结单中止]] -->

        <!-- 结单中止成功弹窗[[ -->
        <div class="g-popup g-popup-transparent js-popup-commit-success f-hide">
            <div class="popup-con commit-success">
                <div class="popup-close js-close-view"><i class="ico ico-close"></i></div>
                <h5 class="popup-title">提交成功</h5>
                <div class="confirm-content">
                    <div class="confirm-ico"></div>
                    <span class="confirm-tip">提交成功,</span>
                    <span class="confirm-tip-text">请等审核收结果</span>
                </div>
            </div>
        </div>
        <!-- 结单中止成功弹窗]] -->


        <div class="order-message f-clearfix">
            <img class="order-detail-header f-fl" :src="supplierOrderInfo.game_logo" width="80" height="80">
            <div class="order-detail-intro f-fr">
                <div class="order-name-contain f-clearfix">
                     <span class="order-name f-hide-col-1">{{ supplierOrderInfo.order_name }}</span>
                    <span class="status f-fr">{{ supplierOrderInfo.orderStatusText }}</span>
                </div>
                <div class="order-lines order-type-line">
                    <div class="order-num">单号:
                        <span class="order-num-detail">{{ supplierOrderInfo.id }}</span>
                    </div>
                    <div class="budget-all" style="width: 200px">含税总预算:
                        <div class="budget-all-num" style="color: #666"><span class="money-ico">￥</span>  {{ $common.toThousandsFilter(parseFloat(supplierOrderInfo.budget_amount)+parseFloat(supplierOrderInfo.budget_tax)) }}</div>
                    </div>
                    <div class="budget-all">税后实收:
                        <div class="budget-all-num" style="color: #666"><span class="money-ico">￥</span>{{supplierOrderInfo.amount}}</div>
                        <div class="ask-ico">
                            <div class="answer-show">
                                <i class="triangle"></i>
                                <div class="answer-text">税费￥
                                    {{ $common.toThousandsFilter(supplierOrderInfo.budget_tax)}}
                                    由腾讯公司代缴</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-type-line">
                    <div class="order-num">类型:
                        <span class="order-num-detail">{{ supplierOrderInfo.demandTypeText }}({{ supplierOrderInfo.content_type }})</span>
                    </div>
                    <div class="budget-all" style="width: 200px">含税实际额:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>{{getRealAmountAddTax}}
                        </div>
                    </div>
                    <div class="budget-all">税后实收:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>{{supplierOrderInfo.real_amount}}
                        </div>
                        <div class="ask-ico">
                            <div class="answer-show">
                                <i class="triangle"></i>
                                <div class="answer-text">税费￥{{ $common.toThousandsFilter(supplierOrderInfo.real_tax) }}已由腾讯公司代缴</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-time-line">
                    <div class="order-num">时间:
                        <span class="order-num-detail">{{ supplierOrderInfo.start_time }}-{{ supplierOrderInfo.end_time }}</span>
                    </div>
                    <div class="budget-all">单价:
                        <div class="contain f-hide-col-1">
                            <div class="budget-all-num">视频<span class="money-ico">￥</span><span class="money-num">400</span>/篇;</div>
                            <div class="budget-all-num">图文<span class="money-ico">￥</span><span class="money-num">150</span>/篇;</div>
                            <div class="budget-all-num">小说<span class="money-ico">￥</span><span class="money-num">250</span>/篇;</div>
                            <div class="budget-all-num">漫画<span class="money-ico">￥</span><span class="money-num">250</span>/篇;</div>
                        </div>
                        <div class="answer-show">
                            <i class="triangle"></i>
                            <div class="answer-text">视频￥400/篇； 图文￥150/篇； 小说￥250/篇；漫画￥400/篇；</div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-type-num-line">
                    小说：<span class="order-num-detail">{{ supplierOrderInfo.novel }}</span>
                    视频：<span class="order-num-detail">{{ supplierOrderInfo.video}}</span>
                    漫画：<span class="order-num-detail">{{ supplierOrderInfo.painting}}</span>
                    图文：<span class="order-num-detail">{{ supplierOrderInfo.text}}</span>
                </div>
                <div class="order-lines order-tips-line">
                    <div class="order-num">说明:
                        <span class="order-num-detail f-hide-col-1">{{ supplierOrderInfo.cycle_explain }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="commit-task g-autofixheight">
            <!-- 选项卡[[ -->
            <div class="g-tab tab1">
                <a href="javascript:;" v-for="(item,index) in tabList" :key="index" @click="changeTab(index)">
                    <div class="g-tab-item" :class="{'g-tab-item-active': index == curTab}">{{item}}</div>
                </a>
            </div>
            <!-- 选项卡]] -->
            <!-- 内容审核[[ -->
            <div class="order-detail-status order-detail-status-1" v-if="curTab == 0">
                <div class="searchs-list">
                    <div class="search f-clearfix">
                        <div class="list f-fl state-select">
                            <p class="name f-fl"><label for="keyword">作者QQ</label></p>
                            <div class="g-select f-fl">
                                <input class="input"
                                       name="keyword"
                                       type="text"
                                       placeholder="请输入作者QQ"
                                       v-model.trim="params.authorQq">
                            </div>
                        </div>
                        <div class="list f-fl list-title">
                            <p class="name f-fl"><label for="keyword">订单名称</label></p>
                            <div class="g-select f-fl">
                                <input
                                        class="input"
                                        name="keyword"
                                        type="text"
                                        placeholder="请输入订单名称"
                                        v-model.trim="params.authorOrderName"
                                >
                            </div>
                        </div>
                        <div class="inquire f-fr">
                            <input class="btn" type="button" value="查询" @click="getAuthorOrderList">
                        </div>
                    </div>
                    <ul class="freelance-list">
                        <li class="list" v-for="order in authorOrderList" :key="order.id">
                            <div class="file-con f-clearfix">
                                <div class="file-intro f-fl">
                                    <span class="file-name f-hide-col-1">{{ order.order_name }}</span>
                                    <div class="type-detal-con">
                                        <div class="type-item">
                                            图文：<span class="type-num">{{ order.articlesPass }}/</span><span class="type-all">{{ order.articlesPre }}</span>
                                        </div>
                                        <div class="type-item">
                                            视频：<span class="type-num">{{ order.videoPass }}/</span><span class="type-all">{{ order.videoPre }}</span>
                                        </div>
                                    </div>
                                    <div class="type-detail-con">
                                        <div class="type-item">
                                            小说：<span class="type-num">{{ order.novelPass }}/</span><span class="type-all">{{ order.novelPre }}</span>
                                        </div>
                                        <div class="type-item">
                                            漫画：<span class="type-num">{{ order.cartoonPass }}/</span><span class="type-all">{{ order.cartoonPre }}</span>
                                        </div>
                                    </div>
                                    <div class="date">{{ order.start_time }}－{{ order.end_time }}</div>
                                </div>
                                <div class="budget f-fl">
                                    <div class="type-item f-hide-col-1">
                                        {{ order.userName }}{{ order.author_type === 1 ?  '（团长）' : '（作者）'}}
                                        <span class="type-all">  {{ order.object_name }}</span>
                                    </div>
                                    <div class="type-item f-hide-col-1">
                                        含税总预算<span class="type-all">{{ $common.toThousandsFilter(order.totalBudgetTax)}}</span>
                                    </div>
                                    <div class="type-item f-hide-col-1">
                                        含税实际额<span class="type-all">{{ $common.toThousandsFilter(order.realAmountTax)}}</span>
                                    </div>
                                    <a class="switch js-down1" href="javascript:;">周期说明
                                        <i class="ico" :class="order.showDesc ? 'ico-up' : 'ico-down'" @click="order.showDesc = !order.showDesc">
                                        </i></a>
                                </div>

                                <!-- 制单中[[ -->
                                <div class="operation status-text f-fr" v-if="order.order_status == 6001">
                                    <p class="status"><span class="color-theme">制单中</span></p>
                                    <!--<p class="btn">-->
                                        <!--<a class="g-btn" href="javascript:;" @click="handleClick(order,'edit')">编辑</a>-->
                                        <!--<a class="g-btn" href="javascript:;" @click="handleClick(order,'delete')">删除</a>-->
                                    <!--</p>-->
                                </div>



                                <!-- 结算中]] -->
                                <!-- 制单中]] -->
                                <!-- 待接单[[ -->
                                <div class="operation wait-accept js-wait-accept f-fr" v-else-if="order.order_status == 6002">
                                    <p class="status"><span class="color-theme">待接单</span></p>
                                    <p class="btn">
                                        <a class="g-btn" href="javascript:;" @click="handleClick(order,'stop')">中止</a>
                                    </p>
                                </div>
                                <!-- 待接单]] -->
                                <!-- 已接单[[ -->
                                <div class="operation wait-accept js-wait-accept f-fr" v-else-if="order.order_status == 6003">
                                    <p class="status"><span class="color-theme">已接单</span></p>
                                    <p class="btn">
                                        <a class="g-btn" href="javascript:;"  @click="handleClick(order,'stop')">中止</a>
                                    </p>
                                </div>
                                <!-- 已接单]] -->
                                <!-- 执行中[[ -->
                                <div class="operation wait-accept js-order-break f-fr" v-else-if="order.order_status == 6006">
                                    <p class="status"><span class="color-theme">执行中</span></p>
                                    <p class="btn">
                                        <a class="g-btn" href="javascript:;" @click="handleClick(order,'supplierStop')">结单中止</a>
                                    </p>
                                </div>
                                <!-- 执行中]] -->
                                <!-- 待结单[[ -->
                                <div class="operation wait-accept js-wait-done f-fr" v-else-if="order.order_status == 6007">
                                    <p class="status"><span class="color-theme">待结单</span></p>
                                    <p class="btn">
                                        <a class="g-btn" href="javascript:;" @click="handleClick(order,'reject')">驳回</a>
                                    </p>
                                </div>
                                <!-- 待结单]] -->

                                <!-- 支付失败[[ -->
                                <div class="operation status-text status-other-text f-fr" v-else-if="order.order_status == 6011">
                                    <p class="status"><span class="color-theme">支付失败</span></p>
                                </div>
                                <!-- 支付失败]] -->
                                <!-- 中止[[ --> <!-- 支付成功]] -->
                                <div class="operation status-text status-text-gary f-fr"  v-else-if="[6020].includes(order.order_status)">
                                    <p class="status"><span class="color-theme">中止</span></p>
                                </div>
                                <!-- 终止结算 -->
                                <div class="operation status-text status-text-gary f-fr"  v-else-if="[6021].includes(order.order_status)">
                                    <p class="status"><span class="color-theme">终止结算</span></p>
                                </div>
                                <!-- 中止]] -->   <!-- 支付成功[[ -->

                                <!-- 结算中[[ -->
                                <div class="operation status-text f-fr" v-else>
                                    <p class="status"><span class="color-theme">{{ order.orderStatusText }}</span></p>
                                </div>
                                <!-- 结算中]] -->
                            </div>
                            <div class="circle-intro js-circle-show1" style="display: block" v-if="order.showDesc" >
                                {{ order.cycle_explain }}
                            </div>
                        </li>
                    </ul>

                    <!-- 空数据 start -->
                    <div class="empty" v-if="authorOrderList.length=== 0">
                        <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png"/>
                    </div>
                    <!-- 空数据 end -->
                </div>
                <div class="footer-bar">
                    <div class="footer-bar-btn">
                        <div class="g-bottom-btn btn-group">
                            <a class="button f-fr" href="javascript:;" @click="goBack">返回</a>
                            <!--选中状态  为a标签添加类 active -->
                            <a class="button f-fr" href="javascript:;" @click="showAssignDialog" v-if="supplierOrderInfo.order_status == 5000">派单</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 内容审核]] -->
            <div v-if="curTab == 1">
                <div class="order-detail-status order-detail-status-2"  >
                    <div class="searchs-list">
                        <div class="search f-clearfix">
                            <select-box
                                    :selectList="pageConf.articleTypeList"
                                    itemTitle="内容类型"
                                    :selected.sync="params.type"
                                    :placeholder="'请选择内容类型'">
                            </select-box>
                            <select-box
                                    :selectList="pageConf.articleStatusList"
                                    itemTitle="内容状态"
                                    :selected.sync="params.status"
                                    :placeholder="'请选择内容类型'">
                            </select-box>
                            <div class="list f-fl list-title">
                                <p class="name f-fl"><label for="keyword">订单名称</label></p>
                                <div class="g-select f-fl">
                                    <input class="input" name="keyword" type="text" placeholder="请输入订单名称" v-model="params.title"><!--0629修改-->
                                </div>
                            </div>
                            <div class="inquire f-fr">
                                <input class="btn" type="button" value="查询" @click="getSupplierOrderArticleList">
                            </div>
                        </div>
                        <ul class="freelance-list">
                            <li class="list"  v-for="article in articleList">
                                <div class="f-clearfix">
                                    <p class="pic f-fl"><img :src="article.cover" width="197" height="111" alt=""></p>
                                    <div class="txt f-fl">
                                        <!-- 不带原创标签[[ -->
                                        <h3 class="title"><span class="type">【{{ article.articleTypeText }}】</span>
                                            <a class="name f-hide-col-1 js-open-view" href="javascript:;" @click="previewArticle(article)" >
                                                {{ article.articleTitle }}
                                            </a></h3>
                                        <!-- 不带原创标签]] -->
                                        <div class="intro">
                                            <!--王者荣耀-->
                                        </div>
                                        <p class="author">{{ article.userName }} <span class="time">{{ article.created}}</span></p>
                                    </div>
                                    <div class="examine f-fl">
                                        <a class="switch js-down1" href="javascript:;"
                                           @click="article.showMediaDistribute = !article.showMediaDistribute">发布渠道
                                            <i class="ico" :class="article.showMediaDistribute ? 'ico-up' : 'ico-down'"></i>
                                        </a>
                                    </div>
                                    <!-- 待审核[[ -->
                                    <div class="operation wait-accept f-fr" v-if="article.articleStatus ==10 || article.articleStatus == 0">
                                        <p class="status"><span class="color-theme">{{ article.articleStatusText }}</span></p>
                                        <p class="btn" v-if="article.articleStatus ==10">
                                            <a class="g-btn" href="javascript:;" @click="resolve(article.id)">通过</a>
                                            <a class="g-btn js-open-reject" href="javascript:;" @click="reject(article.id)">驳回</a>
                                        </p>
                                    </div>
                                    <!-- 待审核]] -->

                                    <!-- 已通过[[ -->
                                    <div class="operation check-passed f-fr" v-else>
                                        <!--<div class="operation reject-more f-fr">-->
                                        <p class="status"><span class="color-theme">{{ article.articleStatusText }}</span></p>
                                    </div>
                                    <!-- 已通过]] -->
                                </div>
                                <ul class="channel f-clearfix js-channel-show1" style="display: block" v-if="article.showMediaDistribute">
                                    <li class="item f-fl" v-for="media in article.media">
                                        <span class="head"><img :src="media.outCover" width="25" height="25"></span>
                                        <a class="name js-open-channel" href="javascript:;"
                                           style="width: 6rem"
                                           @click="showMediaDistributeDialog(media)"
                                           @mouseenter="media.showRemark = true"
                                           @mouseleave="media.showRemark = false"
                                        >{{ media.accountName }}</a>

                                        <span class="sync sync-success" v-if="media.status==1">同步<i class="ico ico-success"></i></span>
                                        <span class="sync sync-failure" v-else-if="media.status==0">未同步 <i class="ico ico-failure"></i></span>
                                        <span class="sync sync-failure" v-else-if="media.status==3">同步失败<i class="ico ico-failure"></i></span>
                                        <div class="sync-failure-reason" style="display: block" v-if="media.showRemark && media.remark">
                                            <div class="sync-failure-triangle"></div>
                                            <div class="failure-reason-text f-hide-col-1">{{media.remark}}</div>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                        <!-- 空数据 start -->
                        <div class="empty" v-if="articleList.length===0">
                            <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png"/>
                        </div>
                        <!-- 空数据 end -->
                    </div>
                    <div class="footer-bar">
                        <div class="footer-bar-btn">
                            <div class="g-bottom-btn btn-group">
                                <a class="button f-fr" href="javascript:;" @click="goBack">返回</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <!-- 分页[[ -->
            <pagination
                    v-if="paginationConf.total >0"
                    :total="paginationConf.total"
                    :page-size="paginationConf.pageSize"
                    @change="pageChange"
                    ref="pager">
            </pagination>
            <!-- 分页]] -->
            <!--内容预览 start-->
            <content-preview ref="contentPreview"></content-preview>
            <video-preview ref="videoPreview"></video-preview>
            <!--内容预览 end-->
            <media-distribute-info ref="mediaDistributeInfo"></media-distribute-info>

        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import  '~Assets/sass/pages/v4/order/order_unpack.scss';
    @import  '~Assets/sass/pages/v4/order/order_children_detail.scss';
    .js-circle-show1{display: block}
</style>
<script>
import selectBox from 'Components/v4/dropdown/select_box';
import pagination from 'Components/v4/pagination/pagination_v4';
import contentPreview from 'Components/v4/pop/content_preview';
import videoPreview from 'Components/v4/pop/video_preview';
import mediaDistributeInfo from './media_distribute_info';
import {
    SupplierAuthorOrderList, DeleteAuthorOrder,
    StopAuthorOrder, SupplierStopToStatement,
    SupplierRejectAuthorOrder, SupplierArticlePass,
    SupplierArticleReject, SupplierOrderArticleList, SupplierOrderInfo, ArticleDelete,
    AssignSupplierOrderInfo, AssignSupplierOrder, TeamAll, SaveAuthorOrder
} from 'Services/getData.js';
import {
    MAP_ARTICLE_TYPE_LIST, MAP_ARTICLE_STATUS_LIST
} from 'Services/paramsConfig.js';
export default {
    name: 'v4-order-author-detail-ugc',
    data() {
        return {
            supplierOrderInfo: {},
            authorOrderList: [],
            articleList: [],
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            tabList: ['作者订单', '内容审核'],
            curTab: 0,
            params: {
	                supplierOrderId: '',
	                authorQq: '',
	                authorOrderName: '',
	                pageSize: 10,
	                pageIndex: 0, // 作者订单列表用
	                type: '', // 0：图文；1：视频；2：图集；50：小说；60：漫画
	                title: '',
                status: '',
                page: 1 // 内容列表用的
            },
            pageConf: {
                articleTypeList: [
                    {
                        name: '请选择', id: '' 
                    },
                    {
                        name: "图文", id: 0 
                    },
                    {
                        name: "视频", id: 1 
                    },
                    {
                        name: "小说", id: 50 
                    },
                    {
                        name: "漫画", id: 60 
                    }
                ],
                demandStatusList: [
                    {
                        id: 0, name: '全部', num: ''
                    },
                    {
                        id: 4003, name: '执行中', num: ''
                    },
                    {
                        id: 4004, name: '已结单', num: ''
                    }
                ],
                contentTypeList: [
                    {
                        id: 0, name: '全部类型'
                    },
                    {
                        id: 1, name: 'PGC'
                    },
                    {
                        id: 2, name: 'PUGC'
                    },
                    {
                        id: 3, name: 'UGC'
                    }
                ],
                demandTypeList: [
                    {
                        name: '内容创作', id: 10
                    },
                    {
                        name: '劳务服务', id: 20
                    },
                    {
                        name: '福利奖金', id: 30
                    },
                    {
                        name: '补贴补偿', id: 40
                    }
                ],
                authorOrderStatusList: [
                    {
                        id: 0, name: '请选择订单状态'
                    },
                    {
                        id: 6001, name: '制单中', operation: ['edit', 'delete']
                    },
                    {
                        id: 6002, name: '待接单', operation: ['stop']
                    },
                    {
                        id: 6003, name: '已接单', operation: ['stop']
                    },
                    {
                        id: 6004, name: '待审核', operation: []
                    },
                    {
                        id: 6005, name: '已驳回', operation: []
                    },
                    {
                        id: 6006, name: '执行中', operation: []
                    },
                    {
                        id: 6007, name: '待结单', operation: ['supplierStop']
                    },
                    {
                        id: 6008, name: '待结算', operation: ['reject']
                    },
                    {
                        id: 6009, name: '结算中', operation: []
                    },
                    {
                        id: 6010, name: '支付成功', operation: []
                    },
                    {
                        id: 6011, name: '支付失败', operation: []
                    },
                    {
                        id: 6012, name: '支付中', operation: []
                    },
                    {
                        id: 6020, name: '已中止', operation: []
                    },
                    {
                        id: 6021, name: '终止结算', operation: []
                    }
                ],
                supplierOrderStatusList: [
                    {
                        id: 0, name: '请选择订单状态'
                    },
                    {
                        id: 5000, name: '制单中', operation: ['addAuthorOrder', 'edit', 'assign', 'delSupplierOrder']
                    },
                    {
                        id: 5001, name: '待接单', operation: ['doSubmit']
                    },
                    {
                        id: 5002, name: '已驳回', operation: ['addAuthorOrder', 'edit', 'assign']
                    },
                    {
                        id: 5003, name: '待审核', operation: []
                    },
                    {
                        id: 5004, name: '执行中', operation: ['submitStatement']
                    },
                    {
                        id: 5005, name: '待结单', operation: []
                    },
                    {
                        id: 5006, name: '待结算', operation: []
                    },
                    {
                        id: 5007, name: '结算中', operation: []
                    },
                    {
                        id: 5008, name: '支付成功', operation: []
                    },
                    {
                        id: 5009, name: '支付失败', operation: []
                    },
                    {
                        id: 5010, name: '已结单', operation: []
                    },
                    {
                        id: 2020, name: '已中止', operation: []
                    },
                    {
                        id: 5021, name: '终止结算', operation: []
                    }
                ],
                articleStatusList: [
                    {
                        name: '全部', id: ''
                    },
                    {
                        name: '草稿中', id: 0
                    },
                    {
                        name: '待审核', id: 10
                    },
                    {
                        name: '外团已通过', id: 15
                    },
                    {
                        name: '供应商已通过', id: 18
                    },
                    {
                        name: '已通过', id: 20
                    },
                    {
                        name: '已发布', id: 30
                    },
                    {
                        name: '已驳回', id: 50
                    },
                    {
                        name: '已定时', id: 40
                    },
                    {
                        name: '已下线', id: 60
                    },
                    {
                        name: '已删除', id: 70
                    }
                ],
                articleStatusMap: {}

            }, // 临时数据
            tmp: {
                demandTypeList: {},
                orderStatusList: {},
                supplierOrderStatusList: {}
            },
            assignOrderDialog: {
                show: false,
                supplierOrderId: '',
                authorList: []
            },
            // 新建或保存作者订单
            aOrderParams: {
                supplierOrderId: '',
                authorOrderId: '',
                orderName: '',
                startTime: '',
                endTime: '',
                cycleExplain: '',
                textNum: '',
                videoNum: '',
                novelNum: '',
                paintingNum: '',
                authorType: 1,
                teamId: '',
                authorQQ: '',

                dateVal: [],
                budget: ''
            },
            authorOrderDialog: {
                show: false
            }
        }
    },
    components: {
        selectBox, pagination, contentPreview, videoPreview, mediaDistributeInfo
    },
    created() {
        this.pageConf.authorOrderStatusList.filter((type) => {
            this.tmp.orderStatusList[type.id] = type.name;
        });
        this.pageConf.supplierOrderStatusList.filter((type) => {
            this.tmp.supplierOrderStatusList[type.id] = type.name;
        });
    },
    mounted() {
        if(this.$route.query.id) {
            this.params.supplierOrderId = this.$route.query.id;
            this.getSupplierOrderInfo();
            this.getAuthorOrderList();
            this.getAllTeams();
        }else{
            this.$router.go(-1);
        }
    },
    watch: {},
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        changeTab(index){
            this.paginationConf.total = 0;
            this.params.pageIndex = 0;
            this.params.page = 1;
            this.curTab = index;
            if(this.curTab){
                this.getSupplierOrderArticleList();
            }else{
                this.getAuthorOrderList();
            }
        },
        handleClick(order, action) {
            let tips = {
                delete: '删除', 'edit': '编辑', stop: '中止', reject: '驳回', supplierStop: '结单中止'
            };
            let tip = tips[action] ? tips[action] : '';
            this.$confirm(`确认执行${tip}操作？`, '提示', {
                'confirmButtonText': '确认', cancelButtonText: '取消' 
            })
                .then(() => {
                    switch (action){
                    case 'delete':
                        this.deleteAuthorOrder(order);
                        break;
                    case 'edit':
                        this.editAuthorOrder(order);
                        break;
                    case 'stop':
                        this.stopAuthorOrder(order);
                        break;
                    case 'supplierStop':    // 结单中止
                        this.supplierStopToStatement(order);
                        break;
                    case 'reject':
                        this.rejectAuthorOrder(order);
                        break;
                    }
                }).catch(() => {});
        },
        showAssignDialog() {
            this.getAssignSupplierOrderInfo();
        },
        async resolve(id){
            this.$confirm('确认通过吗', '提示', {
                'confirmButtonText': '确认', cancelButtonText: '取消' 
            })
                .then(async () => {
                    let res = await SupplierArticlePass({
                        articleId: id
                    });
                    if(res.data.code==0){
                        this.getSupplierOrderArticleList();
                    }
                }).catch(() => {});
        },
        async reject(id){
            this.$prompt('请输入驳回原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(async ({
                value 
            }) => {
                let res = await SupplierArticleReject({
                    articleId: id, reason: value
                });
                if(res.data.code==0){
                    this.getSupplierOrderArticleList();
                }
            }).catch(() => {
            });
        },
        editAuthorOrder(authorOrder) {
            let {
                order_name, start_time, end_time, cycle_explain, id, object_name, author_type, novelPre,
                articlesPre, cartoonPre, videoPre, isReceiver, object_id
            } = authorOrder;
            this.aOrderParams.authorOrderId = id;
            this.aOrderParams.orderName = order_name;
            this.aOrderParams.dateVal = [start_time, end_time];
            this.aOrderParams.startTime = start_time;
            this.aOrderParams.endTime = end_time;
            this.aOrderParams.textNum = articlesPre;
            this.aOrderParams.videoNum = videoPre;
            this.aOrderParams.paintingNum = cartoonPre;
            this.aOrderParams.novelNum = novelPre;
            this.aOrderParams.orderName = order_name;
            this.aOrderParams.cycleExplain = cycle_explain;
            if(author_type==1){ // 团长
                this.aOrderParams.authorType = 1;
                this.aOrderParams.teamId = object_id;
            }else{
                this.aOrderParams.teamId = '';
                this.aOrderParams.authorType = 2;
                this.aOrderParams.authorQQ = object_name;
            }
            this.authorOrderDialog.show = true;
        },
        cancelSubmitAuthorOrder() {
            this.authorOrderDialog.show = false;
        },
        async getAssignSupplierOrderInfo(){
            let response = await AssignSupplierOrderInfo({
                supplierOrderId: this.supplierOrderInfo.id
            });
            let result = response.data;
            if(result.code === 0){
                this.assignOrderDialog.authorList = result.data;
                this.assignOrderDialog.show = true;
                this.assignOrderDialog.supplierOrderId = this.supplierOrderInfo.id;
            }
        },
        submitAuthorOrder() {
            let {
                authorType, orderName, teamId, authorQQ, cycleExplain, textNum, videoNum, novelNum, paintingNum
            } = this.aOrderParams;
            if(!orderName){
                this.$alert('请填写作者订单名称~');
                return false;
            }
            if(!(textNum && videoNum && novelNum && paintingNum)){
                this.$alert('请填写内容数量~');
                return false;
            }
            if(authorType === 1 && !teamId){
                this.$alert('请选择团队或填写作者QQ~');
                return false;
            }
            if(!orderName){
                this.$alert('请填写作者订单名称~');
                return false;
            }
            if(!cycleExplain){
                this.$alert('请填写作者订单说明~');
                return false;
            }
            let param = this.aOrderParams;
            if(param.authorType ==2){
                if(!authorQQ){
                    this.$alert('请填写作者QQ~');
                    return false;
                }
                param.teamId = '';
            }
            if(param.dateVal.length < 2){
                this.$alert('请填写订单时间~');
                return false;
            }
            param.startTime = param.dateVal[0];
            param.endTime = param.dateVal[1];
            param.supplierOrderId = this.params.supplierOrderId;
            this.saveAuthorOrder(param);
        },
        async saveAuthorOrder(param){
            let response = await SaveAuthorOrder(param);
            let result = response.data;
            if(result.code === 0){
                this.$alert('操作成功');
                this.authorOrderDialog.show = false;
                this.getAuthorOrderList();
            }
        },
        previewArticle(article){
            if(article.articleType == 1){
                this.$refs.videoPreview.remotePreview(article.id);
            }else{
                this.$refs.contentPreview.loadInfo(article.id);
            }
        },
        editArticle(article) {
		        this.$router.history.push({
                name: 'v4-order-contribute', query: {
                    id: article.id
                }
            });
        },
        deleteArticle (article) {
            this.$confirm('确认删除此内容吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnClickModal: false
            }).then(()=>{
                this.doDeleteArticle(article.id);
            }).catch(()=>{});
        },
        pageChange (param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.pageIndex = param.pageIndex - 1; // 发送给接口的字段
            this.params.page = param.pageIndex; // 发送给接口的字段
            if(this.curTab){
	                this.getSupplierOrderArticleList();
            }else{
	                this.getAuthorOrderList();
            }
        },
        async assignOrder(){
            let response = await AssignSupplierOrder({
                supplierOrderId: this.assignOrderDialog.supplierOrderId
            });
            let result = response.data;
            this.assignOrderDialog.show = false;
            if(result.code === 0){
                this.$alert('操作成功');
                this.goBack();
                // this.getSupplierOrderList();
            }
        },
        async doDeleteArticle(id){
            let res = await ArticleDelete(id);
            if(res.status === 200 && res.data && res.data.code == 0){
                this.$alert('操作成功');
            }else{
                // this.$alert(res.data.info);
            }
            this.getSupplierOrderArticleList();
        },
        showMediaDistributeDialog(media){
            this.$refs.mediaDistributeInfo.show(media);
        },
        async deleteAuthorOrder(order){
            let response = await DeleteAuthorOrder({
                authorOrderId: order.id
            });
            if(response.data.code === 0){
                this.$alert('操作成功');
                this.getSupplierOrderInfo();
                this.getAuthorOrderList();
            }
        },
        async rejectAuthorOrder(order){
            let response = await SupplierRejectAuthorOrder({
                authorOrderId: order.id
            });
            if(response.data.code === 0){
                this.$alert('操作成功');
                this.getSupplierOrderInfo();
                this.getAuthorOrderList();
            }
        },
        async supplierStopToStatement(order){
            let response = await SupplierStopToStatement({
                authorOrderId: order.id
            });
            if(response.data.code === 0){
                this.$alert('操作成功');
                this.getSupplierOrderInfo();
                this.getAuthorOrderList();
            }
        },
        async stopAuthorOrder(order){
            let response = await StopAuthorOrder({
                authorOrderId: order.id
            });
            if(response.data.code === 0){
                this.$alert('操作成功');
                this.getSupplierOrderInfo();
                this.getAuthorOrderList();
            }
        },
        async getSupplierOrderInfo() {
            let param = {
                orderId: this.params.supplierOrderId
            };
            let res = await SupplierOrderInfo(param);
            if(res.status === 200 && res.data.code == 0) {
                let data = res.data;
                if (data.code == 0) {
                    let order = data.data;
                    order.demandTypeText = this.tmp.demandTypeList[order.demand_type];
                    order.orderStatusText = this.tmp.supplierOrderStatusList[order.order_status];
                    this.supplierOrderInfo = order;
                }else{
                    setTimeout(	this.$router.history.push({
                        name: 'v4-order-demand'
                    }), 1000)
                }
            }
        },
        async getAuthorOrderList() {
            let param = this.params;
            let response = await SupplierAuthorOrderList(param);
            let result = response.data;
            if(result.code === 0){
                this.authorOrderList = result.data.data.map((order)=>{
                    order.orderStatusText = this.tmp.orderStatusList[order.order_status];
                    order.showDesc = false;
                    return order;
                });
                this.paginationConf.total = result.data.count;
            }
        },
        async getSupplierOrderArticleList(){
            let response;
            let param = this.params;
            response = await SupplierOrderArticleList(param);
            let result = response.data;
            if(response.status == 200 && result.code == 0){
                this.articleList = result.data.data.map((article)=>{
                    article.showMediaDistribute = false;
                    article.articleStatusText = '';
                    if(MAP_ARTICLE_STATUS_LIST.has(article.articleStatus)){
                        article.articleStatusText = MAP_ARTICLE_STATUS_LIST.get(article.articleStatus);
                    }
                    if(MAP_ARTICLE_TYPE_LIST.has(article.articleType)){
                        article.articleTypeText = MAP_ARTICLE_TYPE_LIST.get(article.articleType);
                    }
                    article.operation = [];
                    return article;
                });
                this.paginationConf.total = result.data.total;
            }
        },
        viewAuthorOrderDetail(supplierOrderInfo) {
            this.$router.history.push({
                name: 'v4-order-author-detail-ugc', params: supplierOrderInfo
            })
        },
        objToStrMap(obj) {
            let strMap = new Map();
            for (let v of Object.values(obj)) {
                strMap.set(v.id, v.name);
            }
            return strMap;
        },
        async getAllTeams() {
            let response = await TeamAll();
            let result = response.data;
            if(result.code === 0){
                this.teamList = result.data;
            }
        }
    },
    computed: {
	        getRealAmountAddTax() {
		        if(isNaN(this.supplierOrderInfo.real_amount)){
			        return this.supplierOrderInfo.real_amount;
            }
		        let real_tax = isNaN(this.supplierOrderInfo.real_tax) ? 0 : parseFloat(this.supplierOrderInfo.real_tax);
		        let real_amount = isNaN(this.supplierOrderInfo.real_amount) ? 0 : parseFloat(this.supplierOrderInfo.real_amount);
		        return this.$common.toThousandsFilter(real_tax+ real_amount)
        },
	        getBudgetAddTax() {
		        let budget_amount =isNaN(this.supplierOrderInfo.budget_amount) ? 0 : parseFloat(this.supplierOrderInfo.budget_amount);
		        let budget_tax = isNaN(this.supplierOrderInfo.budget_tax) ? 0 : parseFloat(this.supplierOrderInfo.budget_tax);
		        return this.$common.toThousandsFilter(budget_amount+ budget_tax)
	        },
	        getBudget() {
		        let [videoPrice, articlePrice, paintingPrice, novelPrice ]= [400, 150, 400, 250];
		        let {
                videoNum, textNum, paintingNum, novelNum
            } = this.aOrderParams;
		        videoNum = parseInt(videoNum) > 0 ? parseInt(videoNum) : 0;
		        textNum = parseInt(textNum) > 0 ? parseInt(textNum) : 0;
		        novelNum = parseInt(novelNum) > 0 ? parseInt(novelNum) : 0;
		        paintingNum = parseInt(paintingNum) > 0 ? parseInt(paintingNum) : 0;
		        let num = videoNum * videoPrice + textNum * articlePrice + paintingPrice * paintingNum + novelNum* novelPrice;
		        return num;
	        },
	        getTeamLeader() {
		        let leader = '';
		        this.teamList.filter((team)=>{
			        if(team.id == this.aOrderParams.teamId){
				        leader = team.leader;
			        }
		        });
		        return leader;
	        }

    }
}
</script>
